import { useTranslation } from "react-i18next";

import { APPS } from "shared/config/constants";

export const useManagerTranslate = () =>
  useTranslation(APPS.manager, { keyPrefix: "manager-app" });
